export default {
	superAdmin: "SuperAdmin",
	clientAdmin: "ClientAdmin",
	siteUser: "SiteUser",
};
